<template>
    <v-app>
        <v-dialog v-model="showSplashScreen" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-img
                class="white--text"
                height="100%"
                width="100%"
                gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                :src="imagem"
            >
            </v-img>
        </v-dialog>
        <v-app-bar app
            v-show="showAll" flat fixed
        >
            <v-tabs v-model="tabs" optional show-arrows>
                <v-tab key="/pendentes" @click="tabChange('/pendentes')">Pendentes</v-tab>
                <v-tab disabled key="/proximas" @click="tabChange('/proximas')">Proximas</v-tab>
                <v-tab key="/pessoal" @click="tabChange('/pessoal')">Pessoal</v-tab>
                <template v-for="item in storeClientes.data">
                    <v-tab @click="tabChangeCliente(item.id)">{{item.nome}}</v-tab>
                </template>
            </v-tabs>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-menu open-on-hover bottom offset-y class="hidden-xs-only">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on">
                        <v-icon left>fas fa-user-circle</v-icon>
                        {{ userName }}
                    </v-btn>
                </template>
               <!--  <v-btn text slot="activator">
                  <v-icon left>fas fa-user-circle</v-icon>
                  {{ userName }}
                </v-btn> -->
                <v-list dense>
                    <v-list-item @click="showConfiguracoes">
                        <v-list-item-action>
                            <v-icon>settings</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Configurações</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="doLogout">
                        <v-list-item-action>
                            <v-icon>logout</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>&nbsp;&nbsp;Sair</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-content
            v-show="showAll"
            class="ml-5 mr-5"
        >
            <router-view/>
        </v-content>

        <!-- <v-footer :fixed="fixed" app>
          <span>&copy; 2018</span>
        </v-footer> -->
        <v-snackbar
            v-model="snackbar"
            color="white"
            style="border-left: 6px solid; border-color: #C8E6C9 ;color: rgba(0,0,0,.87);"
            :bottom="popUpConfig.y === 'bottom'"
            :left="popUpConfig.x === 'left'"
            :multi-line="popUpConfig.mode === 'multi-line'"
            :right="popUpConfig.x === 'right'"
            :timeout="popUpConfig.timeout"
            :top="popUpConfig.y === 'top'"
            :vertical="popUpConfig.mode === 'vertical'"
        >
            {{ popUpConfig.text }}
            <template v-if="popUpConfig.action">
                <v-btn
                    color="green lighter-4"
                    text
                    @click="callPopUpAction"
                >
                    {{ popUpConfig.actionLabel }}
                </v-btn>
            </template>
        </v-snackbar>
        <v-dialog
            v-model="dialog"
            max-width="290"
        >
            <v-card style="border-left: 6px solid; border-color: #C8E6C9">
                <v-card-text class="pa-5" color="green lighter-4">
                    {{ dialogConfig.text }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green lighter-4"
                        text
                        @click="dialog = false"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="errorDialog"
            max-width="290"
        >
            <v-card style="border-left: 6px solid; border-color: red">
                <v-card-text color="red" class="pa-5">
                    {{ errorDialogMsg }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red darken-1"
                        text
                        @click="errorDialog = false"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{ confirmDialogConfig.title }}</v-card-title>
                <v-card-text>{{ confirmDialogConfig.text }}</v-card-text>
                <v-card-actions>
                    <v-btn color="green lighter-4" dark text @click="callConfirmDialogAction">Ok</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="confirmDialog = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="loadingDialog"
            persistent
            width="300"
        >
            <v-card class="pa-3">
                <v-card-text>
                    {{loadingDialogMsg}}
                    <v-progress-linear
                        indeterminate
                        color="green lighter-4"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <TarefaForm v-bind:id="tarefaDetalhesConfig.id" v-bind:cliente="tarefaDetalhesConfig.cliente" v-bind:showDialog="tarefaDetalhes"/>
        <Configuracoes v-bind:showDialog="isShowConfiguracoes"/>
    </v-app>
</template>

<script>
import Utils from '@/utils/Utils';
import { EventBus } from '@/EventBus';
import { Store } from '@/utils/Store.js';
import TarefaForm from '@/views/TarefaForm.vue'
import Configuracoes from '@/views/configuracoes/Main.vue'

export default {
    components: {
        TarefaForm,
        Configuracoes
    },
    watch: {
        // call again the method if the route changes
        $route: 'setRouteTab'
    },
    beforeMount() {
        const self = this;
        if (['/login', '/logout'].indexOf(this.$route.path) < 0) {
            Utils.apiAjax({
                url: '/permissoes/Autenticacao',
                success: (data) => {
                    if (data.success === false) {
                        const sessionObj = JSON.parse(localStorage.getItem('vue-session-key')) || {};
                        if (sessionObj.Sessao !== undefined && sessionObj.Sessao !== '') {
                            localStorage.setItem('vue-session-solicitacoes-expired', 'EXPIRED');
                        }
                        self.$router.push('/login');
                        self.showSplashScreen = false;
                        self.showAll = true;
                    } else {
                        self.showSplashScreen = false;
                        self.showAll = true;
                    }
                },
                failure: () => {
                    const sessionObj = JSON.parse(localStorage.getItem('vue-session-key')) || {};
                    if (sessionObj.Sessao !== undefined && sessionObj.Sessao !== '') {
                        localStorage.setItem('vue-session-solicitacoes-expired', 'EXPIRED');
                    }
                    self.$router.push('/login');
                    setTimeout(() => {
                        self.showAll = true;
                        self.showSplashScreen = false;
                    }, 1000);
                }
            });
        } else {
            setTimeout(() => {
                self.showSplashScreen = false;
                self.showAll = true;
            }, 1000);
        }
    },
    mounted() {
        this.userName = this.$session.get('Nome');
        EventBus.$on('loginSuccessful', () => {
            this.userName = this.$session.get('Nome');
        });
        EventBus.$on('sessionExpired', () => {
            this.onSessionExpired();
        });
        EventBus.$on('showPopUp', (eventParam) => {
            this.popUpConfig.text = eventParam.text;
            this.popUpConfig.actionLabel = eventParam.actionLabel;
            this.popUpConfig.action = eventParam.action;
            this.showPopUp();
        });
        EventBus.$on('showErrorDialog', (eventParam) => {
            this.errorDialogMsg = eventParam;
            this.showErrorDialog();
        });
        EventBus.$on('showDialog', (eventParam) => {
            this.dialogConfig.title = eventParam.title;
            this.dialogConfig.text = eventParam.text;
            this.dialogConfig.action = eventParam.action;
            this.showDialog();
        });
        EventBus.$on('showConfirmDialog', (eventParam) => {
            this.confirmDialogConfig.title = eventParam.title;
            this.confirmDialogConfig.text = eventParam.text;
            this.confirmDialogConfig.action = eventParam.action;
            this.showConfirmDialog();
        });
        EventBus.$on('showLoadingDialog', (eventParam) => {
            this.loadingDialogMsg = eventParam;
            this.showLoadingDialog();
        });
        EventBus.$on('hideLoadingDialog', () => {
            this.hideLoadingDialog();
        });
        EventBus.$on('showTarefaDetalhes', (eventParam) => {
            this.tarefaDetalhesConfig.id = eventParam.id;
            this.tarefaDetalhesConfig.cliente = eventParam.cliente;
            this.showTarefaDetalhes();
        });
        EventBus.$on('hideTarefaDetalhes', () => {
            this.hideTarefaDetalhes();
        });
        EventBus.$on('hideConfiguracoes', () => {
            this.hideConfiguracoes();
        });
        this.setRouteTab();
    },
    methods: {
        callConfirmDialogAction() {
            if (this.confirmDialogConfig.action) {
                this.confirmDialog = false;
                this.confirmDialogConfig.action(this);
            }
        },
        callDialogAction() {
            if (this.dialogConfig.action) {
                this.dialog = false;
                this.dialogConfig.action(this);
            }
        },
        callPopUpAction() {
            if (this.popUpConfig.action) {
                this.popUpConfig.action(this);
            }
        },
        doLogout() {
            Utils.apiAjax({
                url: '/permissoes/Autenticacao',
                method: 'delete',
                success: () => {
                    this.$router.push('/logout');
                },
                failure: () => {
                    this.$router.push('/logout');
                }
            });
        },
        hideConfimDialog() {
            this.confirmDialog = false;
        },
        hideDialog() {
            this.dialog = false;
        },
        hideErrorDialog() {
            this.errorDialog = false;
        },
        hideLoadingDialog() {
            this.loadingDialog = false;
        },
        hidePopUp() {
            this.snackbar = false;
        },
        hideShowNavigationDrawer() {
            if (['lg', 'xl'].indexOf(this.$vuetify.breakpoint.name) >= 0) {
                // telas grandes
                this.navigationDrawer = true;
                this.navigationDrawerConfig.miniVariant = !this.navigationDrawerConfig.miniVariant;
            } else {
                // telas menores
                this.navigationDrawerConfig.miniVariant = false;
                this.navigationDrawer = !this.navigationDrawer;
            }
        },
        hideTarefaDetalhes() {
            this.tarefaDetalhes = false;
            this.tarefaDetalhesConfig.id = null;
            this.tarefaDetalhesConfig.cliente = null;
        },
        hideConfiguracoes() {
            this.isShowConfiguracoes = false;
            window.location.reload();
        },
        onSessionExpired() {
            localStorage.setItem('vue-session-solicitacoes-expired', 'EXPIRED');
            this.$session.destroy();
            this.$router.push('/login');
        },
        showConfirmDialog() {
            this.loadingDialog = false;
            this.confirmDialog = true;
        },
        showDialog() {
            this.loadingDialog = false;
            this.dialog = true;
        },
        showErrorDialog() {
            this.loadingDialog = false;
            this.errorDialog = true;
        },
        showLoadingDialog() {
            this.loadingDialog = true;
        },
        showPopUp() {
            if (this.popUpConfig.action) {
                this.popUpConfig.mode = 'vertical';
            } else {
                this.popUpConfig.mode = 'multi-line';
            }
            this.snackbar = true;
        },
        showTarefaDetalhes() {
            this.tarefaDetalhes = true;
        },
        showConfiguracoes() {
            this.isShowConfiguracoes = true;
        },
        tabChange(moduloUrl) {
            if (moduloUrl) {
                if (this.$route.path != moduloUrl) {
                    this.$router.push(moduloUrl);
                }
            }
        },
        tabChangeCliente(clienteId) {
            if (clienteId) {
                if (this.$route.path != '/cliente/'+clienteId) {
                    this.$router.push('/cliente/'+clienteId);
                }
            }
        },
        toConfiguracoes() {
            this.$router.push('/configuracoes');
        },
        setRouteTab() {
            if (this.$route.path.indexOf('/cliente') >= 0) {
                var clienteId = this.$route.params.pathMatch;
                var idx = this.storeClientes.findById(clienteId);
                if (idx >= 0) {
                    this.tabs = 3 + idx;
                }
                return true;
            }
            switch (this.$route.path) {
                case '/pendentes':
                    this.tabs = 0;
                    break;
                case '/proximas':
                    this.tabs = 1;
                    break;
                case '/pessoal':
                    this.tabs = 2;
                    break;
                default:
                    this.tabs = null;
                    break;
            }
        }
    },
    created() {
        this.storeClientes.load();
    },
    data() {
        return {
            storeClientes: new Store({
                url: '/clientes/Clientes',
                listeners: {
                    load: (storeEl) => {
                        this.setRouteTab();
                    }
                }
            }),
            breadCrumbsConfig: {
                large: true,
                exact: true
            },
            confirmDialog: false,
            confirmDialogConfig: {
                title: '',
                text: '',
                action: false
            },
            dialog: false,
            dialogConfig: {
                title: '',
                text: '',
                action: false
            },
            errorDialog: false,
            errorDialogMsg: '',
            imagem: require('@/assets/wallpaper.jpg'), // eslint-disable-line global-require
            isShowConfiguracoes: false,
            loadingDialog: false,
            loadingDialogMsg: '',
            popUpConfig: {
                x: 'left',
                y: 'bottom',
                mode: 'multi-line',
                // mode: 'vertical',
                timeout: 6000,
                text: '',
                action: false,
                actionLabel: ''
            },
            showAll: false,
            showSplashScreen: true,
            tarefaDetalhes: false,
            tarefaDetalhesConfig: {
                id: null,
                cliente: null
            },
            tabs: 0,
            snackbar: false,
            userName: ''
        };
    },
    name: 'App'
}
</script>